import {
  getSelectDropdownListFloatingConfig,
  SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY_WITH_ADDITIONAL_INFO,
} from '../../Select'

export const USER_SELECT_DROPDOWN_FLOATING_CONFIG =
  getSelectDropdownListFloatingConfig(
    SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY_WITH_ADDITIONAL_INFO
  )
